





































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  configService,
  CouponRequests,
  ExperienceAvailabilityRequests,
  ExperienceInquiryRequests,
  NoProfileGiftsRequests,
  NoProfileReservationsRequests,
  ProfileGiftsRequests,
  ProfileReservationsRequests,
  UtilitiesFunctions,
  UtilitiesRequests
} from "@/helpers";
import RouteTranslations from "@/locales/routerTranslations";
import formRules, { FormRules } from "@/helpers/formRules";
import { mapState } from "vuex";
import Reservation, { InvoiceForm } from "@/models/reservation";
import { User } from "@/models/user";
import Stripe from "../Stripe.vue";
import Gift from "@/models/gift";
import { BaseRequests } from "@/helpers/requests/BaseRequests";
import CustomDatePicker from "@/components/CustomDatePicker.vue";
import moment from "moment";
import Country from "@/models/country";
import "@/plugins/googleMaps";
import { ExperienceInquiry } from '@/models/experience-inquiry';
import NumericPrefix from "@/models/numeric-prefix";
import { ExperienceAvailability } from "@/models/experience-availability";

interface MyRules {
  name: FormRules[];
  surname: FormRules[];
  email: FormRules[];
  confirmEmail: FormRules[];
  numericCode: FormRules[];
  phoneNumber: FormRules[];
  birth_date: FormRules[];
  country: FormRules[];
  beneficiaryNotify: FormRules[];
  select: FormRules[];
  message: FormRules[];
  socialR: FormRules[];
  address: FormRules[];
  cap: FormRules[];
  city: FormRules[];
  province: FormRules[];
  state: FormRules[];
  cf: FormRules[];
  pi: FormRules[];
  idCode: FormRules[];
}

declare const fbq: any;

// Tapfiliate function is on window
declare const tap: (action: string, chargeId: string, amount: number, options: any) => {};

@Component({
  components: {
    Stripe,
    CustomDatePicker
  },
  computed: {
    ...mapState({
      bookingDetails: (state: any) => {
        console.info('state')
        console.info(state);
        return state.booking.bookingDetails
      },
      user: (state: any) => state.session.user
    })
  }
})
export default class BookingSummaryDetail extends Vue {
  bookingDetails!: any;
  user!: User;
  experience!: any;
  isOnline: boolean = false;
  translations: any = RouteTranslations;
  loading: boolean = false;
  visitReason = "";
  visitReasonTags = null;
  message = "";
  // savedMessage = "";
  privacyBoolean = false;
  privacyMarketingAccepted = false;
  privacyProfileAccepted = false;
  invoiceBoolean = false;
  numericCodeFormItem: any | undefined = undefined;
  phoneNumber = "";
  beneficiaryNotify = "";
  countryFormItem = ""
  profileFormItems?: any | null = null;
  beneficiaryFormItems?: any | null = null;
  optionalFormItems?: any | null = null;
  shippingAddressFormItems?: any | null = null;
  autoCompleteOptions: any = {
    componentRestrictions: {
      country: ['it']
    }
  };
  profileFormValid = false;
  shippingAddressFormValid = false;
  beneficiaryFormValid = false;
  phoneFormValid = false;
  numericFormValid = false;
  invoiceFormItems?: Object | null = null;
  invoiceFormValid = false;
  paymentMethodFormValid = false;
  buttonDisabled = false;
  confirmSave: any = "";
  cardElement: any;
  clientSecret: any = "";
  paymentOK = false;
  paymentLoading = false;
  bookingDetailsReady = false;
  reservationId = "";
  coupon: any = "";
  couponVerified = false;
  couponMessage: any = "";
  couponLoading = false;
  total = 0;
  previousTotal = 0;
  handleRoute = UtilitiesFunctions.handleRoute;
  radios = "radio-1";
  radioColor = "#BA324F";
  loaded: boolean = false;
  paidFor: boolean = false;
  serializedData: any = null;
  relationships: any = null;
  paypalEnabled: boolean = false;

  expandMarketing = false;
  expandProfiling = false;

  countries: Array<Country> = [];
  numericCodes: NumericPrefix[] = [];

  // !!! RULES KEYS MUST MATCH JSON LOCALES KEYS
  myRules: MyRules = {
    name: formRules.nameRules,
    surname: formRules.surnameRules,
    email: formRules.mandatoryEmailRules,
    confirmEmail: [],
    birth_date: [],
    country: formRules.mandatoryCountry,
    numericCode: formRules.mandatoryNumericCode,
    phoneNumber: formRules.mandatoryNumber,
    beneficiaryNotify: formRules.mandatoryDate,
    select: formRules.mandatorySelect,
    message: [],
    socialR: formRules.mandatoryField,
    address: formRules.mandatoryField,
    cap: formRules.mandatoryField,
    city: formRules.mandatoryField,
    province: formRules.mandatoryField,
    state: formRules.mandatoryField,
    cf: formRules.mandatoryTaxCodeRules,
    pi: formRules.mandatoryField,
    idCode: formRules.mandatoryField
  };
  redeemData: any;

  get dateFormatted() {
    return UtilitiesFunctions.dateFormatter(this.bookingDetails.startAt);
  }

  get startTimeFormatted() {
    return this.bookingDetails.time;
  }

  created() {
    this.total = this.bookingDetails.total;
    this.previousTotal = this.bookingDetails.total;
    this.isOnline = (this.bookingDetails.experience.experienceTypeTags || []).some(t => t.code == 'smart');
    console.warn('a:>' + (!this.bookingDetails.priceLabels || !this.bookingDetails.priceLabels.size) && !this.bookingDetails.experience.isInquiry)
    if (!this.bookingDetails.adults && (!this.bookingDetails.priceLabels || !this.bookingDetails.priceLabels.length) && !this.bookingDetails.experience.isInquiry) {
      const toRoute = UtilitiesFunctions.handleRoute("home");
      // this.$router.push(toRoute);
      this.$router.go(-1);
    }
    this.$store.state.app.tagsList.forEach((tag: any) => {
      if (tag.code === "visit_reasons") this.visitReasonTags = tag.tags;
    });
    UtilitiesRequests.getCountries().then((list: Array<Country>) => {
      this.countries = list;
    });
    UtilitiesRequests.getNumericCodes().then((list: NumericPrefix[]) => {
      this.numericCodes = list;
    })
    
    
  }

  get priceLabel() {
    return this.total > 0
      ? "€ " + this.total.toFixed(2)
      : this.$t("general.free");
  }

  mounted() {

    const dataLayer: any = (window as any).dataLayer;

    if (this.bookingDetails.isGift) {
      //push step1 GA checkout behavior for Gift

      dataLayer.push({
        'event': 'EEcheckout',
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': 1, 'option': this.bookingDetails.experience.title },
            'products': [{
              'name': this.bookingDetails.experience.title,
              'id': this.bookingDetails.experience.id,
              'quantity': this.bookingDetails.adults,
              'category': 'Gift',
              'brand': this.bookingDetails.experience.cellar.title

            }]


          }
        }
      });

    }



    else {

      //push step 1 GA checkout behavior for Reservation
      dataLayer.push({
        'event': 'EEcheckout',
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': 1, 'option': this.bookingDetails.experience.title },
            'products': [{
              'name': this.bookingDetails.experience.title,
              'id': this.bookingDetails.experience.id,
              'quantity': this.bookingDetails.adults,
              'category': 'Reservation',
              'brand': this.bookingDetails.experience.cellar.title

            }]

          }
        }
      });
    }



    // this.payPalButtonSet();
    this.bookingDetailsReady = true;

    // Keys used in v-for forms
    const profileItems = ["name", "surname", "email", "confirmEmail"];
    const beneficiaryItems = ["name", "surname", "email", "confirmEmail"];
    const optionalItems = ["birth_date", "country"];
    const shippingAddressItems = ['country', 'addressLine1', 'addressLine2', 'city', 'province', 'region', 'zipcode']

    const invoiceItems = [
      "name",
      "surname",
      "socialR",
      "address",
      "cap",
      "city",
      "province",
      "state",
      "cf",
      "pi",
      "idCode",
      "email",
      "phoneNumber",
      "numericCode",
      "country"
    ];
    this.profileFormItems = this.buildInputModels(profileItems);
    this.beneficiaryFormItems = this.buildInputModels(beneficiaryItems);
    this.optionalFormItems = this.buildInputModels(optionalItems);
    this.shippingAddressFormItems = this.buildInputModels(shippingAddressItems);

    if (this.bookingDetails.redeem) {
      this.beneficiaryFormItems.beneficiary_name = "2";
    }

    this.invoiceFormItems = this.buildInputModels(invoiceItems);

    if (this.bookingDetails.redeem) {
      this.profileFormItems["email"] =
        this.bookingDetails.redeem.beneficiary_email ? this.bookingDetails.redeem.beneficiary_email.toLowerCase() : "";
      this.profileFormItems["name"] =
        this.bookingDetails.redeem.beneficiary_firstname || "";
      this.profileFormItems["surname"] =
        this.bookingDetails.redeem.beneficiary_lastname || "";
      this.profileFormItems["confirmEmail"] =
        this.bookingDetails.redeem.beneficiary_email ? this.bookingDetails.redeem.beneficiary_email.toLowerCase() : "";
    } else if (this.user) {
      this.profileFormItems["email"] = this.user.email || "";
      this.profileFormItems["name"] = this.user.firstName || "";
      this.profileFormItems["surname"] = this.user.lastName || "";
      this.profileFormItems["email"] = this.user.email || "";
      this.profileFormItems["confirmEmail"] = this.user.email || "";
      this.phoneNumber = this.user.phone || "";
      this.countryFormItem = this.countryFormItem || "";
    }
  }

  @Watch("profileFormValid")
  handleEmailCouponReset(val: boolean) {
    if (!val) {
      this.coupon = "";
    }
  }

  @Watch("coupon")
  handleCouponReset() {
    if (this.couponVerified === true) {
      this.couponMessage = this.$t("booking.summary.couponChanged");
      this.coupon = "";
    }
    this.total = this.previousTotal;
    this.couponVerified = false;
  }

  getTermsUrl(): string {
    const redeemData = this.$store.state.booking.redeemData;

      if (redeemData && redeemData.experience) {
    if (redeemData.experience.terms_of_use_url) {
      return redeemData.experience.terms_of_use_url;
    } else {

      return '#';
    }
  }
    
    return this.handleRoute('terms');
  }

  handleTermsClick(event): void {
    const redeemData = this.$store.state.booking.redeemData;

    if (redeemData && redeemData.experience && !redeemData.experience.terms_of_use_url) {

      event.preventDefault();

      this.$store.dispatch("app/setSnackbarMessage", {
        message: this.$t("booking.summary.noTermsFromWinery"),
        color: "red",
      });
    }

  }

getPrivacyUrl(): string {
  const redeemData = this.$store.state.booking.redeemData;
  
  if (redeemData && redeemData.experience) {
    if (redeemData.experience.privacy_statement_url) {
      return redeemData.experience.privacy_statement_url;
    } else {

      return '#';
    }
  }
  
  return this.handleRoute('privacy');
}
  handlePrivacyClick(event): void {
    const redeemData = this.$store.state.booking.redeemData;
    
    if (redeemData && redeemData.experience && !redeemData.experience.privacy_statement_url) {

      event.preventDefault();
      
      this.$store.dispatch("app/setSnackbarMessage", {
        message: this.$t("booking.summary.noPrivacyPolicyFromWinery"),
        color: "red",
      });
    }

  }



  countryChanged(country: any) {
    this.autoCompleteOptions.componentRestrictions = {
      country: [country.iso]
    }
    this.shippingAddressFormItems['addressLine1'] = '';
    this.shippingAddressFormItems['addressLine2'] = '';
    this.shippingAddressFormItems['city'] = '';
    this.shippingAddressFormItems['province'] = '';
    this.shippingAddressFormItems['region'] = '';
    this.shippingAddressFormItems['zipcode'] = '';
  }

  numericCodeChanged(numericCode: any) {
    this.numericFormValid = !!numericCode
    const b = this.phoneNumber;
    this.phoneNumber = ""
    this.phoneNumber = b;
  }

  placeChanged(address: any) {
    const findByType = (type: string): string | undefined => {
      const v: any = address.address_components.find(e => e.types.some(ei => ei === type))
      return v ? v.short_name : null;
    }

    const city = findByType('locality');
    const region = findByType('administrative_area_level_1');
    const area1 = findByType('administrative_area_level_3');
    const area2 = findByType('administrative_area_level_2');

    this.shippingAddressFormItems['city'] = city;
    this.shippingAddressFormItems['province'] = area2 || area1;
    this.shippingAddressFormItems['region'] = region;
    this.shippingAddressFormItems['addressLine1'] = address.formatted_address;
  }

  areBeneficiaryDataValid() {
    if (this.bookingDetails.isGift) {
      return (
        this.beneficiaryFormValid && this.phoneNumber && this.phoneFormValid && this.numericFormValid
      );
    }
    return true;
  }

  verifyCoupon() {
    this.couponLoading = true;
    if (this.profileFormValid && this.couponVerified === false) {
      const query = `?coupon_code=${encodeURIComponent(this.coupon)}&email=${this.profileFormItems.email}&experience_id=${this.bookingDetails.experience.id}&date=${this.bookingDetails.startAt}&total_cents=${(this.total * 100).toFixed(0)}`;
      // &experience_id=${this.bookingDetails.experienceId}`;
      CouponRequests.fetchAll(query, true)
        .then((response: any) => {
          const [data] = response;
          this.couponLoading = false;
          this.couponVerified = true;
          let newPrice = this.total, appliedDiscountStr = '';
          const total = this.total * 10000;
          if (data.discountType == 'percent') {
            const percent = (total * data.discountPercent) / 100;
            newPrice = Math.round((total - percent) / 100) / 100;
            appliedDiscountStr = `${data.discountPercent}%`
          } else if (data.discountType == 'absolute') {
            const discount = (data.discountCents / 100);
            newPrice = this.total - discount
            appliedDiscountStr = "€ " + discount.toFixed(2)
          }

          this.couponMessage = `${this.$t("booking.summary.couponValid")}  ${appliedDiscountStr}`;
          this.total = newPrice;
        })
        .catch((error: any) => {
          this.couponLoading = false;
          this.couponMessage = this.$t("booking.summary.couponInvalid");
        });
    } else {
      this.couponMessage = this.$t("booking.summary.couponError");
      this.couponLoading = false;
    }
  }

  setPaymentBoolean(value: boolean) {
    this.paymentOK = value;
  }

  privacyAcceptAllChanged(v: any) {
    if (v) {
      this.privacyBoolean = v;
      this.privacyMarketingAccepted = v;
      this.privacyProfileAccepted = v;
    }
  }

  privacyProfileChanged() {
    if (!this.privacyMarketingAccepted) {
      this.privacyMarketingAccepted = this.privacyProfileAccepted;
    }
  }

  privacyMarketingChanged() {
    if (!this.privacyMarketingAccepted) {
      this.privacyProfileAccepted = false;
    }
  }

  emailMatchError(email: string, confirmationEmail: string) {
    return email === confirmationEmail
      ? ""
      : this.$t("formRules.confirmEmailError");
  }

  // saveMessage() {
  //   this.savedMessage = this.message;
  //   this.confirmSave = this.$t("booking.summary.commentSaved");
  //   setTimeout(() => {
  //     this.confirmSave = "";
  //   }, 2000);
  // }

  mapBeneficiaryFormItems() {
    const mappedObj = JSON.parse(JSON.stringify(this.beneficiaryFormItems));
    for (let [key, value] of Object.entries(mappedObj)) {
      const new_key = "beneficiary_" + key;
      mappedObj[new_key] = mappedObj[key];
      delete mappedObj[key];
    }
    return mappedObj;
  }

  buildBookingObject(provider?: 'stripe' | 'paypal', paypalData?: any) {
    const profileData = this.profileFormItems;
    const optionalFormItems = this.optionalFormItems;
    if (typeof this.bookingDetails.adults === "string") {
      this.$store.dispatch("booking/setBookingDetails", {
        adults: parseInt(this.bookingDetails.adults)
      });
    }
    if (typeof this.bookingDetails.children === "string") {
      this.$store.dispatch("booking/setBookingDetails", {
        children: parseInt(this.bookingDetails.children)
      });
    }

    const localDeserializationData = {
      ...profileData,
      ...this.mapBeneficiaryFormItems(),
      ...this.bookingDetails,
      optionalData: {
        birth_date: optionalFormItems['birth_date'] ? optionalFormItems['birth_date'] : null,
        country: this.countryFormItem,
      },
      beneficiaryNotify: this.beneficiaryNotify,
      phone: this.prefix(this.numericCodeFormItem) + this.phoneNumber,
      privacyBoolean: this.privacyBoolean,
      privacyMarketingAccepted: this.privacyMarketingAccepted,
      privacyProfileAccepted: this.privacyProfileAccepted,
      message: this.message,
      coupon: this.coupon ? this.coupon : null,
      paypalData: paypalData ? paypalData : null,
      provider: provider,
      default_min_parties: this.bookingDetails.experience.minParties
    };

    if (this.shippingAddressFormItems.addressLine1) {
      localDeserializationData.shippingAddress = { ...this.shippingAddressFormItems }
    }

    if (!this.bookingDetails.isGift) {
      const storeData = new Reservation().localDeserialization(
        this.bookingDetails
      );
      let serializedInvoice = null;
      if (this.invoiceBoolean) {
        const invoiceData = new InvoiceForm().deserialize(
          this.invoiceFormItems
        );
        serializedInvoice = invoiceData.requestSerialize();
      }
      localDeserializationData.invoiceObject = this.invoiceBoolean
        ? serializedInvoice
        : null;
    }

    const objModel = this.bookingDetails.isGift
      ? new Gift()
      : new Reservation();
    const data = objModel.localDeserialization(localDeserializationData);
    this.serializedData = data.requestSerialize();
    this.relationships = [];
    this.relationships.push({
      relName: "experience",
      models: { id: this.bookingDetails.experienceId, _type: "experience" }
    });
    const tagModels: any = [];
    tagModels.push({ id: this.bookingDetails.language.id, _type: "tag" });
    if (this.visitReason && !this.bookingDetails.isGift)
      tagModels.push({ id: this.visitReason, _type: "tag" });

    this.relationships.push({
      relName: "tags",
      models: tagModels
    });
  }


  cleanObj(obj: any) {
    const resObj = JSON.parse(JSON.stringify(obj));
    Object.entries(resObj).forEach(o =>
      o[1] === null || o[1] === "" ? delete resObj[o[0]] : 0
    );
    return resObj;
  }


  handleLinkTap(link: string) {
    const toRoute: string = this.translations[this.$i18n.locale][link].link;
    this.$router.push({ path: toRoute });
  }

  buildInputModels(keys: string[]) {
    function buildByInputKeys(acc: any, key: any) {
      return { ...acc, [key]: "" };
    }

    const object = keys.reduce(buildByInputKeys, {});
    return object;
  }

  updateGiftNotifyPicker(id: string, date: string) {
    this.beneficiaryNotify = date;
  }

  sendFbPixelData(type: string) {
    let data: any = null;

    switch (type) {
      case "AddPaymentInfo":
        data = {
          content_category: this.bookingDetails.isGift ? 'gift' : 'book',
          content_ids: [this.bookingDetails.experience.id],
          currency: this.bookingDetails.experience.priceCurrency,
          contents: [
            {
              'id': this.bookingDetails.priceLabel,
              'quantity': this.bookingDetails.adults
            },
            {
              'id': this.bookingDetails.price2Label,
              'quantity': this.bookingDetails.children
            }
          ],
          value: this.total
        };
        break;
      case "Purchase":
        data = {
          content_ids: [this.bookingDetails.experience.id],
          currency: this.bookingDetails.experience.priceCurrency,
          content_name: this.bookingDetails.experience.title,
          contents: [
            {
              'id': this.bookingDetails.priceLabel,
              'quantity': this.bookingDetails.adults
            },
            {
              'id': this.bookingDetails.price2Label,
              'quantity': this.bookingDetails.children
            }
          ],
          content_type: "product",
          value: this.total
        };
        break;
    }

    // fbq("track", type, data);
  }


  sendGTMData(data: any) {
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    let gtmData: any = {
      event: 'reservation',
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': data.data.id,
            'revenue': data.data.attributes.coupon ? parseFloat(data.data.attributes.total_amount) * (1 - data.data.attributes.coupon.discount_percent / 100) : data.data.attributes.total_amount,
            'coupon': data.data.attributes.coupon ? data.data.attributes.coupon.code : null
          },
          'products': [{
            'name': this.bookingDetails.experience.title,
            'id': this.bookingDetails.experience.id,
            'price': data.data.attributes.coupon ? parseFloat(this.bookingDetails.experience.price) * (1 - data.data.attributes.coupon.discount_percent / 100) : this.bookingDetails.experience.price,
            'category': data.data.type,
            'quantity': data.data.attributes.adults,
            'brand': this.bookingDetails.experience.cellar.title,
            'coupon': data.data.attributes.coupon ? data.data.attributes.coupon.code : null


          }]
        }
      }
    };

    //@ts-ignore
    window.dataLayer.push(gtmData);
  }

  handleRequestForInformation() {
    if (process.env.APP_ENV === "production") {
      this.sendFbPixelData("RequestForInformation");
    }
    this.createExperienceInquiry();
  }

  handleProceed() {
    this.loading = true;

    if (this.bookingDetails.isGift) {
      this.loading = false;
      this.book()
    } else {
      this.getExperienceAvailability(
        this.bookingDetails.experienceId,
        this.bookingDetails.startAt,
        this.bookingDetails.time,
        this.getIsoOfSelectedLanguage
      )
        .then(availability => {
          this.loading = false;
          let totalGuests = this.getTotalGuests()
          if (totalGuests >= availability.calculcatedMinAdults
            && totalGuests <= (availability.calculcatedMaxAdults - availability.adultsCount)) {
            this.book();
          } else {
            this.$store.dispatch("app/setSnackbarMessage", {
              message: this.$t("experienceView.availabilityError"),
              color: "red",
            });
          }
        })
        .catch((error: Error) => {
          this.loading = false;
          console.log(error);
          this.$store.dispatch("app/setSnackbarMessage", {
            message: this.$t("experienceView.experienceNotValidErrorMessage"),
            color: "red",
          });
        });
    }
  }

  private book() {
    this.paymentLoading = true;
    this.buildBookingObject();
    if (process.env.APP_ENV === "production") {
      this.sendFbPixelData("AddPaymentInfo");
    }
    if (this.total > 0) {
      if (this.$refs.stripeComponent) {
        if (this.bookingDetails.isGift) {
          this.createGift();
        } else {
          this.createReservation();
        }
      } else {
        this.$store.dispatch("app/setSnackbarMessage", {
          message: "Error: check Stripe Ref",
          color: "red"
        });
        this.paymentLoading = false;
      }
    } else {
      if (this.bookingDetails.isGift) {
        this.createGift();
      } else {
        this.createReservation();
      }
    }
  }

  public getTotalGuests(): number {
    const adults = this.bookingDetails.adults || 0;
    const children = this.bookingDetails.children || 0
    const quantityLabelsTotal = this.bookingDetails.priceLabels.map(e => {
      return (e.quantity != null ? e.quantity : (e.qtd != null ? e.qtd : 0));
    }).reduce((x, y) => x + y, 0) || 0;
    const quantityExtrasTotal = this.bookingDetails.priceExtras.map(e => {
      return (e.quantity != null ? e.quantity : (e.qtd != null ? e.qtd : 0));
    }).reduce((x, y) => x + y, 0) || 0;

    let totalGuests = adults + children + quantityLabelsTotal + quantityExtrasTotal;

    return totalGuests;
  }

  getExperienceAvailability(
    experienceId: string,
    day: string,
    time: string,
    enableLangIso: string,
    lang: string = 'it'
  ): Promise<ExperienceAvailability> {
    const params: string[] = [];
    if (day) { params.push(`day=${this.bookingDetails.startAt}`); }
    if (time) { params.push(`time=${this.bookingDetails.time}`); }
    if (enableLangIso) { params.push(`enable_lang_iso=${enableLangIso}`); }
    if (lang) { params.push(`lang=${lang}`); }
    let queryParams = params.join("&");

    return new Promise((resolve, reject) => {
      resolve(ExperienceAvailabilityRequests
        .with({
          ExperienceId: experienceId
        })
        .fetchAll(queryParams));
    });
  }

  get getIsoOfSelectedLanguage() {
    return !!this.bookingDetails.language ? (this.bookingDetails.language.code as string).replace("lang_", "") : "";
  }

  createExperienceInquiry() {
    const pd = this.profileFormItems;
    const localDeserializationData = {
      firstname: pd.name,
      lastname: pd.surname,
      email: pd.email,
      phone: this.phoneNumber,
      privacy_profiling: this.privacyProfileAccepted,
      privacy_marketing: this.privacyMarketingAccepted,
      message: this.message,
      experience_id: this.bookingDetails.experience.id,
      country: this.optionalFormItems['country'] ? this.optionalFormItems['country'] : null

    };
    ExperienceInquiryRequests
      .create(new ExperienceInquiry().deserialize(localDeserializationData))
      .then((response: any) => {
        this.goToSuccessPage(response.data);
      })
      .catch((error: any) => {
        console.error(error)
      });


  }

  //Da AGGIUNGERE FUNZIONE PER FAR PARTIRE LO STEP 2 DEL CHECKOUT BEHAVIOR


  createGift() {
    console.warn(this.serializedData)
    const giftModel = this.user ? ProfileGiftsRequests : NoProfileGiftsRequests;
    giftModel
      .create(this.cleanObj(this.serializedData), this.relationships)
      .then((response: any) => {
        let order = response.data;
        if (this.total > 0) {
          this.processOrder(response)
            .then((result: any) => {
              BaseRequests(
                () =>
                  configService.noProfileGifts +
                  "/" +
                  response.data.data.id +
                  "/pay",
                "order",
                () => {
                }
              )
                .create({ id: response.data.data.id })
                .then(() => {
                  const amount = result.paymentIntent.amount / 100;
                  if (configService.env === 'production') {
                    tap(
                      'conversion',
                      result.paymentIntent.id,
                      amount,
                      {
                        meta_data: { reservation_id: order.data.id },
                        currency: this.bookingDetails.experience.priceCurrency
                      }
                    );
                  }
                  this.goToSuccessPage(order);
                })
                .catch((error: any) => {
                  this.handlePaymentError('An error was occurred');
                  this.paymentLoading = false;
                });
            })
            .catch(error => {
              this.paymentLoading = false;
            });
        } else {
          this.goToSuccessPage(order);
        }
      })
      .catch((error: any) => {
        this.handlePaymentError('Can\'t create gift');
        this.paymentLoading = false;
      });
  }

  handlePaymentError(errorMessage: string) {
    this.$store.dispatch("app/setSnackbarMessage", {
      message: errorMessage,
      color: "red"
    });
    this.paymentLoading = false;
    /*const toRoute = UtilitiesFunctions.handleRoute("paymentOk");
     const queryData: any = {
     payment: "ko"
     };
     if (this.bookingDetails.isGift) queryData.gift = true;
     this.$router.push({
     path: toRoute,
     query: queryData
     });
     this.$store.dispatch("booking/resetBookingDetails");*/
  }

  createReservation() {
    const reservationModel = this.user
      ? ProfileReservationsRequests
      : NoProfileReservationsRequests;
    reservationModel
      .create(this.serializedData, this.relationships)
      .then((response: any) => {
        let order = response.data;
        const metadata = {
          meta_data: { reservation_id: order.data.id },
          currency: this.bookingDetails.experience.priceCurrency
        };
        if (this.total > 0) {
          this.processOrder(response)
            .then((result: any) => {
              const amount = result.paymentIntent.amount / 100;
              if (configService.env === 'production') {
                tap(
                  'conversion',
                  result.paymentIntent.id,
                  amount,
                  metadata
                );
              }
              this.goToSuccessPage(order);
            })
            .catch(error => {
              this.paymentLoading = false;
            });
        } else {
          this.goToSuccessPage(order);
        }
      })
      .catch((error: any) => {
        if (error.data.error && error.data.error === 'gift_code_expired') {
          this.handlePaymentError(error.data.error);
        } else {
          this.handlePaymentError(error.data.errors[0].detail);
        }
        this.paymentLoading = false;
      });
  }

  processOrder(response: any) {
    return new Promise((resolve, reject) => {
      this.reservationId = response.data.data.id;
      const { attributes: data } = response.data.data;
      this.clientSecret = data.payment_client_secret;
      if (this.clientSecret) {
        setTimeout(() => {
          //@ts-ignore
          this.$refs.stripeComponent.stripePaymentHandler()
            .then((result: any) => {
              if (result.error) {
                this.handlePaymentError(result.error.message);
              } else {
                resolve(result);
                /*GuestReservationIdRequests.with({
                 reservationId: `${this.reservationId}/promote`
                 })
                 .create()
                 .then((response: any) => {
                 this.goToSuccessPage();
                 this.$store.dispatch("booking/resetBookingDetails");
                 // The payment has succeeded. Display a success message.
                 })
                 .catch((error: any) => {
                 this.handlePaymentError();
                 });*/
              }
            });
        }, 0);
      } else reject(new Error("client secret received invalid"));
    });
  }

  get today() {
    return moment().toISOString();
  }

  goToSuccessPage(data: any) {
    if (process.env.APP_ENV === "production") {
      this.sendFbPixelData("Purchase");
    }
    this.sendGTMData(data);
    const toRoute = UtilitiesFunctions.handleRoute("paymentOk");
    const queryData: any = {
      payment: "ok"
    };
    if (this.bookingDetails.isGift) queryData.gift = true;
    if (this.bookingDetails.experience.instantBooking) queryData.instantBooking = true;
    queryData.isInquiry = this.bookingDetails.experience.isInquiry;
    this.$router.push({
      path: toRoute,
      query: queryData
    });
    this.$store.dispatch("booking/resetBookingDetails");
  }

  // Paypal related methods - disabled on divinea.com
  payPalButtonSet() {
    const script = document.createElement("script");
    const f = (params) => Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
    const merchantId = this.bookingDetails.experience.paypalAccount
    let queryData: any = {
      currency: 'EUR',
      intent: 'authorize'
    };

    if (merchantId)
      queryData = {
        ...queryData,
        'client-id': configService.paypalPlatformPublishKey,
        'merchant-id': merchantId
      }
    else
      queryData = {
        ...queryData,
        'client-id': configService.paypalPublishKey
      }

    script.src = `https://www.paypal.com/sdk/js?${f(queryData)}`;
    script.addEventListener("load", this.setLoaded);
    document.body.appendChild(script);
  }

  setLoaded() {
    this.loaded = true;
    const paypal = (window as any).paypal;

    paypal.Buttons({
      style: {
        layout: "horizontal",
        color: "white"
      },
      createOrder: (data, actions) => this.paypalCreateOrderInBackend(data, actions),
      onApprove: (data, actions) => this.paypalApproveOrderAndPromote(data, actions),
      onError: (error: any) => {
        //qui bisogna chiudere il dialog e gestire l'errore con snackbar e fare il redirect alla pagina SuccessPayment
        this.handlePaymentError(error.message);
      }
    })
      .render(this.$refs.paypal);
  }

  paypalCreateOrderInBackend(_: any, actions: any) {
    return this
      .createReservationWithPaypal(null)
      .then(response => {
        const { attributes: data } = response.data.data;
        return data.paypal_data.order_id;
      })
  }

  paypalApproveOrderAndPromote(data, actions) {
    this.$store.dispatch("app/setDialog", {
      type: "payPalPaymentStatus",
      state: true,
      persistent: true
    });
    const { orderID } = data;
    const submitAuthorizationID = (paypal_data) => {
      return fetch(configService.payments, {
        method: 'POST',
        body: JSON.stringify({ paypal_data }),
        headers: { 'Content-Type': 'application/json' }
      }).then(res => res.json())
    }
    actions.order
      .authorize()
      .then((authorization: any) => {
        const authorizationID =
          authorization.purchase_units[0].payments.authorizations[0].id;
        this.paidFor = true;
        return Promise.all(
          [submitAuthorizationID({
            order_id: orderID,
            authorization_id: authorizationID
          }),
          Promise.resolve(orderID)]);
      })
      .then((data: any) => {
        const response = data[0];
        const orderID: string = data[1];
        this.$store.dispatch("app/closeDialog");
        this.goToSuccessPage(response);
      })
      .catch((error: any) => {
        //qui bisogna chiudere il dialog e gestire l'errore con snackbar
        if (this.paidFor) console.log("handle refund");
        this.$store.dispatch("app/closeDialog");
        this.$store.dispatch("app/setSnackbarMessage", {
          message: `PAYPAL ERROR1: ${error.message}`,
          color: "red"
        });
        this.handlePaymentError(error.data.errors[0].detail);
      });
  }

  paypalCreateOrder(data: any, actions: any) {
    return actions.order.create({
      purchase_units: [
        {
          description: this.bookingDetails.experience.title,
          amount: {
            currency_code: "EUR",
            value: this.total
          }
        }
      ]
    });
  }

  paypalOnApprove(data: any, actions: any) {
    this.$store.dispatch("app/setDialog", {
      type: "payPalPaymentStatus",
      state: true,
      persistent: true
    });
    const { orderID } = data;
    actions.order
      .authorize()
      .then((authorization: any) => {
        var authorizationID =
          authorization.purchase_units[0].payments.authorizations[0].id;
        this.paidFor = true;
        return Promise.all(
          [this.createReservationWithPaypal({
            orderID,
            authorizationID
          })
            , Promise.resolve(orderID)]);
      })
      .then((data: any) => {
        const response = data[0];
        const orderID: string = data[1];
        this.$store.dispatch("app/closeDialog");
        // const amount = response.data.data.attributes.total_amount;
        // if (configService.env === 'production') {
        //   tap(
        //       'conversion',
        //       orderID,
        //       amount,
        //       { meta_data: { reservation_id: response.data.data.id } }
        //   );
        // }
        this.goToSuccessPage(response.data);
      })
      .catch((error: any) => {
        //qui bisogna chiudere il dialog e gestire l'errore con snackbar
        if (this.paidFor) console.log("handle refund");
        this.$store.dispatch("app/closeDialog");
        this.$store.dispatch("app/setSnackbarMessage", {
          message: `PAYPAL ERROR1: ${error.message}`,
          color: "red"
        });
        this.handlePaymentError(error.data.errors[0].detail);
      });
  }

  createReservationWithPaypal(paypalData?: any) {
    this.buildBookingObject('paypal', paypalData);
    if (process.env.APP_ENV === "production") {
      this.sendFbPixelData("AddPaymentInfo");
    }

    let model = null;

    if (this.bookingDetails.isGift)
      model = this.user ? ProfileGiftsRequests : NoProfileGiftsRequests;
    else
      model = this.user
        ? ProfileReservationsRequests
        : NoProfileReservationsRequests;

    return model.create(
      this.bookingDetails.isGift
        ? this.cleanObj(this.serializedData)
        : this.serializedData,
      this.relationships
    );
    // return Promise.reject(new Error("error creating reservation"));
    // return Promise.resolve();
  }

  displayNumericSlice(numeric: NumericPrefix): string {
    if (!numeric) return '';
    return `+${numeric.phonePrefix} | ${numeric.isoCode3.join(", ")}`
  }

  prefix(numeric: any): string {
    if (!!numeric && !!numeric.phonePrefix)
      return '+' + numeric.phonePrefix + ' '
    else
      return ''
  }
}
